//SaveData
export class SaveDataObj {
    obj: object;
    hash: string;

    constructor() {
        this.obj = {};
        this.hash = "";
    }

    append(name: string, value: any) {
        this.obj[name] = value;
        this.hash = this.hash + JSON.stringify({ n: name, v: value });
    }

    getHash(ignoreFields: string[]): string {
        let result = "";
        Object.getOwnPropertyNames(this.obj).forEach(name => {
            if (ignoreFields.indexOf(name) < 0) {
                result = result + JSON.stringify({ n: name, v: this.obj[name] });
            }
        });
        return result;
    }
}